import _ from 'lodash';
import { QueryString } from '~/utils';
import { get, post, del, patch, put } from './agent';

const integrations = (workspacesUrl) => () => {
  const url = _([workspacesUrl, 'integrations']).compact().join('/');

  return {
    get: (query = {}) => get(url.concat(new QueryString(query).toString(true))),
    getStatus: () => get(url.concat('/status')),
    accounting: {
      options: (query = {}) => get(url.concat('/accounting/options').concat(new QueryString(query).toString(true))),
    },

    harvest: {
      get: (query = {}) => get(url.concat('/harvest').concat(new QueryString(query).toString(true))),
      save: (body) => {
        return post(url.concat('/harvest'), body);
      },
      export: (area, config) =>
        get(url.concat('/harvest/export').concat(new QueryString({ area }).toString(true)), config),
      import: (area, importAsRoles = true) => {
        return get(
          url
            .concat('/harvest/import')
            .concat(new QueryString({ area: area, importAsRoles: !!importAsRoles }).toString(true)),
        );
      },
    },

    importCSV: {
      ledgers: (area, config) => get(url.concat('/csv-import/ledgers').concat(), config),
      send: (file, importType) => {
        return put(url.concat('/csv-import').concat(new QueryString({ importType }).toString(true)), file, {
          headers: { 'Content-Type': 'text/csv' },
        });
      },
    },

    slack: {
      get: () => get(url.concat('/slack')),
      getChannel: (channelId) => get(url.concat(`/slack/channel/${channelId}`)),
      getChannels: () => get(url.concat('/slack/channels')),
      getConnected: () => get(url.concat('/slack/connected')),
      getUsers: () => get(url.concat('/slack/users')),
      updateNotifications: (body) => patch(url.concat('/slack/notifications'), body),
      remove: () => del(url.concat('/slack')),
    },

    microsoft: {
      connection: {
        getAuthorizeUri: () => get(url.concat('/microsoft/connection/authorize-uri')),
        getAdminConsentUri: () => get(url.concat('/microsoft/connection/admin-consent-uri')),
        updateSignIn: (body) => put(url.concat('/microsoft/connection/sign-in'), body),
      },
      teams: {
        get: () => get(url.concat('/microsoft/teams')),
        getConnected: () => get(url.concat('/microsoft/teams/connected')),
        getMembers: () => get(url.concat('/microsoft/teams/members')),
        removeLink: (memberId) => del(url.concat(`/microsoft/teams/links/${memberId}`)),
        getChannels: () => get(url.concat('/microsoft/teams/channels')),
        getProjectChannels: () => get(url.concat('/microsoft/teams/projects')),
        setProjectChannel: (projectId, body) => put(url.concat(`/microsoft/teams/projects/${projectId}`), body),
        removeProjectChannel: (projectId) => del(url.concat(`/microsoft/teams/projects/${projectId}`)),
        updateNotifications: (body) => patch(url.concat('/microsoft/teams/notifications'), body),
        remove: () => del(url.concat('/microsoft/teams')),
      },
    },
  };
};

export default integrations;
